import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { postApi } from "../../../Services/apiService";
import { toast } from 'react-toastify';

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailActive, setEmailActive] = useState(false);
  const [passwordActive, setPasswordActive] = useState(false);
  const [errors, setErrors] = useState({ email: "", password: "" });
  const [touched, setTouched] = useState({ email: false, password: false });
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => { 
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    if (userDetails) {
        navigate("/admin/inout"); 
    }
  }, [navigate]); 
  useEffect(() => {
    document.body.classList.add("login-page");
    return () => {
      document.body.classList.remove("login-page");
    };
  }, []);

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!email) return "Email is required.";
    if (!emailRegex.test(email)) return "Please enter a valid email address.";
    return "";
  };

  const validatePassword = (password) => {
    if (!password) return "Password is required.";
    if (password.length < 6) return "Password must be at least 6 characters.";
    return "";
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    if (touched.email) {
      setErrors({...errors, email: validateEmail(value)});
    }
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    if (touched.password) {
      setErrors({...errors, password: validatePassword(value)});
    }
  };

  const handleBlur = (field) => {
    setTouched({...touched, [field]: true});
    if (field === 'email') {
      setErrors({...errors, email: validateEmail(email)});
    } else if (field === 'password') {
      setErrors({...errors, password: validatePassword(password)});
    }
  };

  const validateForm = () => {
    const emailError = validateEmail(email);
    const passwordError = validatePassword(password);
    
    setErrors({
      email: emailError,
      password: passwordError
    });
    
    setTouched({
      email: true,
      password: true
    });

    return !emailError && !passwordError;
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setLoader(true); 
    try {
      const response = await postApi("/login", { email, password });
      if (response?.success === true) {
        localStorage.setItem("userDetail", JSON.stringify(response?.data?.user));
        localStorage.setItem("token", JSON.stringify(response?.data.token));
        // toast.success(response.msg || "Login successful!"); 
        
        setLoader(false);
        navigate("/admin/inout");
      } else {
        toast.error(response.msg || "Login failed"); 
        setLoader(false);
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error(error.response?.data?.msg || "An error occurred during login"); 
      setLoader(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <div className="sign-up-main login">
        <div className="sign-right">
          <div className="logo" onClick={() => navigate("/")}>
            <h5>We Make IT <span className="line"></span></h5>
            <h2 className="mb-0">
              Happen<span>.</span>
            </h2>
            <h2 className="mb-0 green-text">Better<span>.</span>
            </h2>
          </div>
        </div>
        <div className="sign-left">
          <div className="start-rifgr-sec">
            <div className="text-center mb-4">
              <img src={window.getPublicUrl("/assets/images/logo.svg")} alt="Logo" />
            </div>
            <div className="login-container">
              <p className="same-pera text-center">Welcome,</p>
              <h2>Login to your account</h2>
              <form onSubmit={handleLogin}>
                <div className={`form-group ${emailActive ? "active" : ""}`}>
                  <label>Email</label>
                  <input
                    className={`form-control ${errors.email && touched.email ? "is-invalid" : ""}`}
                    type="email"
                    placeholder="Enter Email Address"
                    value={email}
                    onChange={handleEmailChange}
                    onKeyDown={(e) => { if (e.key === " ") e.preventDefault(); }}
                    onFocus={() => setEmailActive(true)}
                    onBlur={() => { 
                      setEmailActive(!!email); 
                      handleBlur('email');
                    }}
                  />
                  {errors.email && touched.email && (
                    <div className="invalid-feedback d-block">{errors.email}</div>
                  )}
                </div>

                <div className={`form-group position-relative ${passwordActive ? "active" : ""}`}>
                  <label>Password</label>
                  <input
                    className={`form-control ${errors.password && touched.password ? "is-invalid" : ""}`}
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter Password"
                    value={password}
                    onChange={handlePasswordChange}
                    onFocus={() => setPasswordActive(true)}
                    onBlur={() => { 
                      setPasswordActive(!!password); 
                      handleBlur('password');
                    }}
                    onKeyDown={(e) => { if (e.key === " ") e.preventDefault(); }}
                  />
                  <span 
                    className="eye-icon" 
                    style={{ cursor: "pointer" }} 
                    onClick={togglePasswordVisibility}
                  >
                    <img
                      src={
                        showPassword
                          ? window.getPublicUrl("/assets/images/Eye.svg")
                          : window.getPublicUrl("/assets/images/Eye-closed.svg")
                      }
                      alt="Toggle Password"
                    />
                  </span>
                  {errors.password && touched.password && (
                    <div className="invalid-feedback d-block">{errors.password}</div>
                  )}
                </div>

                <div className="custom-container d-block">
                  <label className="remember checbox-cs ps-0">
                    <input type="checkbox" />
                    <span className="checkmark"></span>Remember Me
                  </label>
                  <Link to="/forgot-password" className="forget-password float-end">
                    Forgot Password
                  </Link>
                </div>

                <Button 
                  type="submit"
                  variant="sign-in" 
                  disabled={loader}
                >
                  {loader ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Signing in...
                    </>
                  ) : (
                    "Sign in"
                  )}
                </Button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;